
import { useMsal } from "@azure/msal-react";
import { GreyButton } from './Style'; 
import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
export const SignInButton = () => {
  const { instance } = useMsal();

  const handleSignIn = () => {
    instance.loginRedirect({
      scopes: ["user.read"],
    });
  };

  return <Button variant="contained" color="error"  onClick={handleSignIn} sx={{ height: '48px' }}>Sign In</Button>;
};
